import { capitalize } from '@mui/material';

// per figma if the string contains a forward slash we want the next word
// to be capitalized and we want a space around the forward slash as well
export const handleForwardSlash = (text: string): string =>
  text
    .split('/')
    .map((coverage) => capitalize(coverage.toLowerCase()))
    .join(' / ');

// This helper is being used to eliminate unnecessary fields that communicate
// nothing of value to the user as requested by the business.
export const shouldShowCoverageText = (text?: string): boolean => {
  if (!text) return false;
  return !['none', 'yes'].includes(text.toLowerCase());
};
